/** Estado de filtros/paginação da listagem de Países. */
export interface CountryFilters {
  /** Texto de busca aplicado (client-side, por código ou nome). */
  readonly search: string;
  /** Página atual (1-indexed) da paginação client-side. */
  readonly page: number;
}

/** Estado inicial (sem busca, primeira página). */
export const INITIAL_COUNTRY_FILTERS: CountryFilters = {
  search: '',
  page: 1,
};
